"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawalChallengeSchema = exports.OperationListSchema = exports.OperationSchema = exports.ExchangeOperationSchema = exports.DepositOperationSchema = exports.WithdrawalOperationSchema = exports.ConfirmWithdrawalRequestSchema = exports.CreateWithdrawalRequestSchema = exports.DepositStatusSchema = exports.RESERVING_WITHDRAWAL_STATUSES = exports.TERMINAL_WITHDRAWAL_STATUSES = exports.WithdrawalStatusSchema = void 0;
const zod_1 = require("zod");
const exchange_1 = require("./exchange");
const wallet_1 = require("./wallet");
exports.WithdrawalStatusSchema = zod_1.z.enum([
    'awaiting_confirmation',
    'confirmed',
    'submitted',
    'in_review',
    'approved',
    'broadcast',
    'completed',
    'failed',
    'rejected',
    'expired',
]);
/** Statuses that can still change. Everything else is final and stops the poller. */
exports.TERMINAL_WITHDRAWAL_STATUSES = [
    'completed',
    'failed',
    'rejected',
    'expired',
];
/**
 * Statuses whose amount is still on the master address and therefore reduces what the user may
 * withdraw next. From `broadcast` on the funds have left and Fluxson's balance already reflects it.
 */
exports.RESERVING_WITHDRAWAL_STATUSES = [
    'awaiting_confirmation',
    'confirmed',
    'submitted',
    'in_review',
    'approved',
];
/** A deposit exists only once Fluxson confirmed it; `reversed` is a reorg after that (deposits spec 4.2). */
exports.DepositStatusSchema = zod_1.z.enum(['confirmed', 'reversed']);
exports.CreateWithdrawalRequestSchema = zod_1.z.object({
    assetCode: zod_1.z.string().min(1),
    toAddress: zod_1.z.string().trim().min(1).max(128),
    /** Atomic units, strictly positive. The chain-specific format check happens server-side. */
    amount: wallet_1.AtomicAmountSchema.refine((value) => /[1-9]/.test(value), {
        message: 'amount must be greater than zero',
    }),
});
exports.ConfirmWithdrawalRequestSchema = zod_1.z.object({ code: zod_1.z.string().regex(/^\d{6}$/) });
const OperationBase = {
    id: zod_1.z.uuid(),
    assetCode: zod_1.z.string(),
    symbol: zod_1.z.string(),
    decimals: zod_1.z.number().int().min(0),
    chainCode: zod_1.z.string(),
    chainName: zod_1.z.string(),
    amount: wallet_1.AtomicAmountSchema,
    /** Withdrawal: the recipient. Deposit: the user's own master address the funds landed on. */
    toAddress: zod_1.z.string(),
    txHash: zod_1.z.string().nullable(),
    explorerUrl: zod_1.z.url().nullable(),
    createdAt: zod_1.z.iso.datetime(),
    /** Withdrawal: when it completed on chain. Deposit: Fluxson's confirmation timestamp. */
    completedAt: zod_1.z.iso.datetime().nullable(),
};
exports.WithdrawalOperationSchema = zod_1.z.object({
    ...OperationBase,
    type: zod_1.z.literal('withdrawal'),
    status: exports.WithdrawalStatusSchema,
    errorCode: zod_1.z.string().nullable(),
});
/** Strict so a stray `errorCode` on a deposit is a contract violation, not silently dropped. */
exports.DepositOperationSchema = zod_1.z
    .object({
    ...OperationBase,
    type: zod_1.z.literal('deposit'),
    status: exports.DepositStatusSchema,
})
    .strict();
/** An exchange in the feed: the amount is what left the wallet; `toAmount` is the fiat the exchanger pays. */
/** Not strict, like WithdrawalOperationSchema: a field added by a newer API must not break an older Mini App bundle during a rolling deploy. */
exports.ExchangeOperationSchema = zod_1.z.object({
    ...OperationBase,
    type: zod_1.z.literal('exchange'),
    status: exchange_1.ExchangeStatusSchema,
    toAmount: wallet_1.AtomicAmountSchema,
    toDecimals: zod_1.z.number().int().min(0),
    toAlpha3: zod_1.z.string(),
    toCurrencyName: zod_1.z.string(),
    errorCode: zod_1.z.string().nullable(),
});
/** One row of the Mini App operations feed; `type` tells the client which shape it holds. */
exports.OperationSchema = zod_1.z.discriminatedUnion('type', [
    exports.WithdrawalOperationSchema,
    exports.DepositOperationSchema,
    exports.ExchangeOperationSchema,
]);
exports.OperationListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.OperationSchema),
    nextCursor: zod_1.z.string().nullable(),
});
/** The challenge returned by create and resend; mirrors the onboarding OTP challenge. */
exports.WithdrawalChallengeSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    status: exports.WithdrawalStatusSchema,
    emailMasked: zod_1.z.string(),
    expiresAt: zod_1.z.iso.datetime(),
    resendAvailableAt: zod_1.z.iso.datetime(),
});
//# sourceMappingURL=withdrawals.js.map